
/* Copyright(c) 2025 APSS Media Pvt. Ltd.
*  All Rights Reserved
*/
/*
@author:Nilesh Zinzurao-5668
@Creation Date:20-05-2025
@Description:UI for CAT Review Lead
*/

import React from "react";
import Footer from '../layouts/footer';
import PublisherNavigation from '../layouts/navPage';
import { saveAs } from 'file-saver';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logoutUser } from '../login/authentication';
import { withRouter } from 'react-router-dom';
// import { Table } from 'antd'; //sunita-task-3271-added code for ant table 
import { Table, Select, Input, Tooltip, Icon, Badge, Button } from "antd"; //Aman-4947-added Tooltip, Icon

import { FaArrowAltCircleLeft } from "react-icons/fa";
import './advertisers.css';
import { css } from "emotion"; //sunita-task-3271-imported css as per requirement
import { LeadReviewLoader } from "../loaders/LeadReviewLoader"; // Sandeep-task-3441-added loader
import { fetch_custom as fetch } from "../../configration/fetch_default_headers";//snehal-task-3768-vAPT URL changes
import styled from "styled-components"; //Aman-4947-added to style tootip

const Swal = require('sweetalert2')
// const queryString = require('query-string');//kiran-4747-removing console warning-no used
const xlsx = require('xlsx');


//sunita-task-3271-added code for table css
const tableCSS = css({
  backgroundColor: "white",
  fontFamily: "sans-serif",
  borderStyle: "bold",
  "& thead  > tr": {
    backgroundImage: "linear-gradient(to right,#28166f,#007cc3) !important",
    // backgroundColor:'#193D8F-#007CC3(linear gradient) !important',
    color: "white",
    fontSize: "12px",
    textAlign: "center",
    fontWeight: "500",
  },
  "& thead > tr >th": {
    textAlign: "center",
    color: "white",
    // backgroundColor:'#193D8F-#007CC3(linear gradient) !important',
  },
});

//Aman-4947-added to hablde list in tooltip
/* //snehal-task-2798-UI/UX-Changes-3.1 */
const HtmlTooltip = styled(Tooltip)`
         backgroundColor: '#f5f5f9',
         color: 'rgba(0, 0, 0, 0.87)',
         maxWidth: 220,
         fontSize: '12px',
         border: '1px solid #dadde9',
         `;


class CATReviewLead extends React.Component {

  constructor() {
    super();
    this.state = {
      fields: {},
      key: 1,
      errors: {},
      campID: '',
      btnDisable: 'disabled1',
      reviewLeadFlag: false,
      reviewlead: [],
      campaignLeadDetails: [],
      uploadLeadFile: [],
      clientDownloadLead: [],
      status: "Accepted",
      parentCampID: '',
      reallocationID: '',
      marketingChannelFlag: false,
      buttonFlag: false,//shivani-task 3089-used this flag to make submit button enable or disabled.
      tableState: { size: "small" }, //Array for table properties
      pageSize: 100,//sunita-task-3271-added code for pagination
      loading: false, //sunita-task-3271-added code for loader
      listLeadCampID: [], //sunita-task-3271-added this array for storing campID when we are coming from dashboard.
      listLeadCampIDSearch: [],/* sunita-task-3271- added this array for search functionality*/
      tableSearchText: "",//sunita-task 3271-added this parameter for search functionality.
      advertiserID: '', //sunita-task-3271- added as per requirement.
      filesData1: '',//sunita-task-3271-added code for file
      loader2: "",////Sandeep-task-3341-used for loader.
      leadStartSelectedDate: "", //Aman-4947-added to store start input Selected date
      leadEndSelectedDate: "", //Aman-4947-added to store end input Selected date
      filterleadDetails: "", //Aman-4947-added to stored filters lead info
      filterleadDetailsCount: "", //Aman-4947-added to stored filters lead info count
      filterleadDetailsSatus: false, //Aman-4947-added to check the status of filter lead and total lead
      stectedStartDateforDisplay: "", //Aman-4947-added to display Selected start date
      stectedEndDateforDisplay: "", //Aman-4947-added to display Selected end date
      selectedDateStart: "", //Aman-4947-added to reset Selected start date from input filed
      selectedDateEnd: "", //Aman-4947-added to reset Selected end date from input filed
      leadDetails: [],
    };


    // this.submitreviewlead = this.submitreviewlead.bind(this);
    this.handleDownloadLeadDetails = this.handleDownloadLeadDetails.bind(this);
    // this.openLinkInBrowser = this.openLinkInBrowser.bind(this);
    this.advLeadreviewDetails = this.advLeadreviewDetails.bind(this);  //sunita-task-3271-handle change for showing left side campaign data.
    this.handleChangeSearch = this.handleChangeSearch.bind(this);  //sunita-task-3271-handle change for search functionality.
    this.displayCampaignSpecification = this.displayCampaignSpecification.bind(this); //sunita-task-3727-added handle change for displaying campaign specification
    this.handleChangePageSize = this.handleChangePageSize.bind(this);  //kiran-4880-added bind to this function
    //Aman-4947-added startDatedateHandleChange and endDatedateHandleChange to bind
    this.startDatedateHandleChange = this.startDatedateHandleChange.bind(this);
    this.endDatedateHandleChange = this.endDatedateHandleChange.bind(this);

    // User Story - 3441 - Sandeep - reference to control Loader
    this.loadingRef = React.createRef(); // shows the Loader
    this.closeLoadingRef = React.createRef(); // hides the Loader

  }



  /**
  * @author Sunita Landge - task 3727
  * @param  Description handle the campaignSpecification on advertiser review lead page
  * @return Description redirect to campaignSpecificationAdvertiserDashboard
  */

  displayCampaignSpecification(e) {
    var campID = this.state.campID;;//Priyanka--4216--accessing campID
    var parentCampID = this.state.reviewlead[0].parentCampID
    sessionStorage.setItem("campID", campID);
    sessionStorage.setItem("parentCampID", parentCampID);
    window.open("/campaignSpecificationAdvertiserDashboard");
    //snehal-task-3766-vAPT URL changes
    // ); //sunita-task-3099-added changes to open link in new tab   
  }



  /**
* @author Sunita Landge
* @param  Description for pagination
* @return return as per page size record
*/

  //sunita-task-3271-added handle change for pagination
  handleChangePageSize(e) {
    var pageSize = e.target.value;
    this.setState({ pageSize: pageSize });
  } //end of handleChangePageSize


  /**
* @author Sunita Landge
* @param  Description  new function created  for showing information of campaign details.
*/

  //sunita-task-3271-added below code for showing right campaign data.
  getCampaignInfo(campID) {
    this.setState({ filterleadDetailsSatus: false }); //Aman-4947-added to set the filter lead status to false
    //This API is for campaign details from campaign table
    fetch("/dashboardAdvertiser/advReviewlead?campID=" + campID)
      .then(res => res.json())
      .then(reviewlead => {
        //kiran-4747-removing console warning-changed == to ===
        /* Chaitanya-5868-Changed Email/Telemarketing to Email & Telemarketing*/
        if ((reviewlead[0].marketingChannel === "TeleMarketing" && reviewlead[0].callAudit === "Yes") || (reviewlead[0].marketingChannel === "Email & Telemarketing" && reviewlead[0].callAudit === "Yes")) {
          this.setState({ marketingChannelFlag: true })
        }
        else {
          this.setState({ marketingChannelFlag: false })
        }

        //sunita-task-3271-added below code to remove uploaded file when clicking on any other campaign id.
        // document.getElementById('abm1').value = ""; 
        // document.getElementById('fileName').value = "";
        // document.getElementsByClassName("successMessage").value = "";
        // document.getElementsByClassName("errorMessage").value = "";

        var parentCampID = reviewlead[0].parentCampID;

        this.setState({ reviewlead: reviewlead, campID: campID, buttonFlag: false, parentCampID });
      }
      ).catch(function (err) { console.log(err) });
  }


  /**
* @author Sunita Landge
* @param  Description new function created for showing lead's campaign id data .
*/

  //sunita-task-3271-showing left side campaign id data
  advLeadreviewDetails(e) {
    // alert("helo")
    e.preventDefault();//kiran-4747-removing console warning-added e.preventDefault();
    this.setState({ loading: true, loader2: "loader_review" });//Sandeep-task-3341
    //Aman-4947-added below this.setstate to reset all the filter values
    this.setState({
      filterleadDetailsSatus: false,
      leadStartSelectedDate: "",
      leadEndSelectedDate: "",
      selectedDateStart: "", // Reset input value
      selectedDateEnd: "", // Reset input value
      loader2: ""
    });
    var campID = e.target.id;
    const { user } = this.props.auth;
    var advertiserID = user.id;
    this.setState({ campID, advertiserID });


    // sunita-task-3271- api for showing table data
    // fetch("/dashboardCAT/CATLeads?campID=" + campID)
    //   .then(res => res.json())
    //   .then(campaignLeadDetails => {

    //     this.setState({ campaignLeadDetails: campaignLeadDetails, loading: false, loader2: "" })//Sandeep-task-3341
    //     if (campaignLeadDetails.length > 0) {
    //       // this.state.btnDisable = 'btn add-button';
    //       this.setState({ btnDisable: 'btn add-button' })//kiran-4747-removing console warning-use setState
    //       this.forceUpdate();
    //     }

    //     //sunita-task-3271-added for voicelog link column
    //     if ((campaignLeadDetails[0].channel === "Telemarketing" && campaignLeadDetails[0].callAudit === "Yes") || (campaignLeadDetails[0].channel === "Email/Telemarkting" && campaignLeadDetails[0].callAudit === "Yes")) {
    //       this.setState({ marketingChannelFlag: true });
    //     }
    //     else {
    //       this.setState({ marketingChannelFlag: false });
    //     }

    //   }).catch(function (err) { console.log(err) });
    this.getCampaignInfo(campID);//sunita-task-3271-this function called for showing right side campaign details data.
    this.fun_Get_Lead_TableData(campID);//sunita-task-3271-called this fun as per requirement for showing table data.

    //sunita-task-3271-added for removing uploaded file name
    var filesData1 = this.state.filesData1;
    if (filesData1 === undefined || filesData1 === "undefined" || filesData1 === "" || filesData1 === null) {
      // var label = document.getElementById('fileName');
      // label.innerHTML = "No File Choosen"
      // this.state.errors.successMessage = "";
      // this.state.errors.errorMessage = "";
      this.setState({
        errors: {
          successMessage: "",
          errorMessage: ""
        }
      });//kiran-4747-removing console warning-use setState
    }


  }


  /**
* @author Sunita Landge
* @param  Description  new function created for showing lead's table data as per campID 
*/

  //sunita-task-3271-showing lead's table data as per camp id
  fun_Get_Lead_TableData(campID) {

    // this.setState({ loading: true });//sunita-task-3271-added for loader
    // const { user } = this.props.auth;
    fetch("/dashboardCAT/CATLeads?campID=" + campID)
      .then(res => res.json())
      .then(campaignLeadDetails => {

        // if(campaignLeadDetails[0].channel==="Telemarketing"|| campaignLeadDetails[0].channel==="Email/Telemarketing")
        // {
        //   this.setState({marketingChannelFlag: true })
        // }
        // else{
        //   this.setState({marketingChannelFlag: false })
        // }

        this.setState({ campaignLeadDetails: campaignLeadDetails, loading: false, reviewLeadFlag: false }); //sunita-task-3271-added code bcz as after uploading file status is showing in bold form when clicking on other campaign id's.
        if (campaignLeadDetails.length > 0) {
          // this.state.btnDisable = 'btn add-button';
          this.setState({ btnDisable: 'btn add-button' })//kiran-4747-removing console warning-use setState
          this.forceUpdate();
        }
      }).catch(function (err) { console.log(err) });

  }

  /**
 * @author Sunita Landge
 * @param  Description for searching campaign id and it's data.
 * @return return the searched data
 */

  //sunita-task-3271-added for search functionality
  handleChangeSearch(e) {
    e.preventDefault();
    let currentList = [];
    // Variable to hold the filtered list before putting into state
    let newList = [];
    let filterData = e.target.value;
    // If the search bar isn't empty
    if (e.target.value === "") {
      newList = this.state.listLeadCampID;
    }
    else {
      // Assign the original list to currentList
      currentList = this.state.listLeadCampID;
      newList = currentList.filter(item => {
        // change current item to lowercase
        const lc = item;
        //const lc = item.toLowerCase();  
        // change search term to lowercase
        const filter = e.target.value.toLowerCase();
        // check to see if the current list item includes the search term
        // If it does, it will be added to newList. Using lowercase eliminates
        // issues with capitalization in search terms and search content
        var data = Object.values(lc);
        var dataFinal = data.toString();
        dataFinal = dataFinal.replace(",", " ");
        var dataToLower = dataFinal.toLowerCase();
        return dataToLower.includes(filter);
      });

    }
    // Set the filtered state based on what our rules added to newList
    this.setState({
      listLeadCampIDSearch: [...newList], tableSearchText: filterData
    });
  }

  // openLinkInBrowser(e) {
  //   e.preventDefault(); //kiran-4747-removing console warning-added e.preventDefault();
  //   var leadInfoID = e.target.id;
  //   fetch("lead/getVoiceLogLink?leadInfoID=" + leadInfoID + "")
  //     .then(res => res.json())
  //     .then(voiceLogDetails => {
  //       this.setState({ voiceLogDetails: voiceLogDetails })
  //       window.open(voiceLogDetails[0].voiceLogLink, '_blank');
  //     }

  //     ).catch(function (err) {
  //       console.log(err)
  //     });

  // }
  componentDidMount() {
    if (!this.props.auth.isAuthenticated) {
      this.props.history.push('/userLogin');
    }
    else {
      //snehal-task-3724-vAPT URL changes
      if (this.props.location.state !== undefined) {
        var campID = this.props.location.state.campID;
      }
      const { user } = this.props.auth; //sunita-task-3271-taken as per requirement.
      var advertiserID = user.id; //sunita-task-3271-taken as per requirement.
      //Sandeep-task-3341-used for loader
      this.setState({ campID, advertiserID, loading: true, loader2: 'loader_review' }); //sunita-task-3271-setstate the values for loading, advid .

      this.fun_getCampDetailsFromTable(campID);   //Priyanka-4216-calling this function to get camp and lead details
      //sunita-task-3271 - added this api for lead data when user click on id from dashboard and come to lead review page .
      // fetch("/dashboardCAT/CATleadReviewCampID", {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      // })
      //   .then((res) => res.json())
      //   .then((listLeadCampID) => {
      //     // {alert("listLeadCampID ==>" + JSON.stringify(listLeadCampID))}
      //     this.setState(
      //       {
      //         listLeadCampID: listLeadCampID, loader2: ""
      //       }
      //     );//Sandeep-task-3441-added loader
      //   })
      //   .catch(function (err) { });
    }
  }

  // handleChange(i, e) {
  //   const { name, value } = e.target;
  //   let campaignLeadDetails = [...this.state.campaignLeadDetails];
  //   campaignLeadDetails[i] = { ...campaignLeadDetails[i], [name]: value };
  //   this.setState({ campaignLeadDetails });
  // }

  handleChange(absoluteIndex, event) {
    const { name, value } = event.target;
    const updatedDetails = [...this.state.campaignLeadDetails];

    //Nilesh-5487- Update the specific field for the record at the absolute index
    updatedDetails[absoluteIndex][name] = value;

    //Nilesh-5487- If the "status" field is being changed and it's not "Rejected", clear the "reason" field
    if (name === "status" && value !== "Advertiser Rejected") {
      updatedDetails[absoluteIndex].reason = "";
    }

    //Nilesh-5487- Update the state with the modified data source
    this.setState({ campaignLeadDetails: updatedDetails });
  }

  onTableChange = (pagination, filters, sorter) => {
    //Nilesh-5487- Update the current page in the state
    this.setState({
      tableState: {
        ...this.state.tableState,
        current: pagination.current, //Nilesh-5487- Update the current page
      },
    });
  };

  /**
   * @author Somnath Keswad
   * @param  Description handle the Download the Lead in excel file
   * @return Description return All details of lead in excel file
   */
  handleDownloadLeadDetails(e) {
    // ✅ Show error if only one date is selected
    if (
      (this.state.leadStartSelectedDate !== "" && this.state.leadEndSelectedDate === "") ||
      (this.state.leadStartSelectedDate === "" && this.state.leadEndSelectedDate !== "")
    ) {
      Swal.fire({
        type: "error",
        text: "Please select both a start date and an end date to download the details.",
        confirmButtonText: "Ok",
        allowOutsideClick: false,
      });
      return; // Stop function execution
    }
    let errors = {};
    let campList = this.state.listLeadCampID; //4588-Nilesh File Naming convention change
    let campDetail = campList.filter((el) => {
      return el.campID == this.state.campID; //kiran-4752-not resolved giving issue while file download
    });
    //snehal-task-3724-vAPT URL changes
    var campID = this.state.campID;   //Priyanka--4216--accessing campID
    var parentCampID = this.state.reviewlead[0].parentCampID;
    if (parentCampID === undefined) { parentCampID = campID; }
    var reallocationID = this.state.reviewlead[0].reallocationID;
    if (this.state.filterleadDetailsSatus === false) {
      Swal.fire({
        allowOutsideClick: false,
        onOpen: () => {
          Swal.showLoading();
          fetch("dashboardCAT/downloadCATLead?campID=" + campID + "")
            .then(res => res.json())
            .then(downloadFiles => {
              // alert("downloadFiles ==>" + JSON.stringify(downloadFiles))
              this.setState({ downloadFiles: downloadFiles })
              if (downloadFiles.success === true) {
                errors['failureMsg'] = "No Data Exists"
                this.setState({ errors: errors });
              } else {
                var ws = xlsx.utils.json_to_sheet(downloadFiles);
                /* add to workbook */
                var wb = xlsx.utils.book_new();
                xlsx.utils.book_append_sheet(wb, ws, "Lead");
                var buf = xlsx.write(wb, { bookType: 'xlsx', type: 'buffer' }); // generate a nodejs buffer
                // var str = xlsx.write(wb, {bookType:'xlsx', type:'binary'});
                /* generate a download */
                function s2ab(s) {
                  var buf = new ArrayBuffer(s.length);
                  var view = new Uint8Array(buf);
                  for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                  return buf;
                }
                //  var fileName = parentCampID + '-' + reallocationID + ".xlsx";
                var fileName = "CAT_Review_" + campDetail[0].clientCampID + "_" + campID + ".xlsx";
                saveAs(new Blob([s2ab(buf)], { type: "application/octet-stream" }), fileName)
                Swal.fire({
                  text: "File Downloaded Successfully",
                  type: "success",
                  confirmButtonText: "Ok",
                  allowOutsideClick: false,
                });
              }
            })
        },
      });
    } else {
      Swal.fire({
        allowOutsideClick: false,
        onOpen: () => {
          Swal.showLoading();
          // alert("hello")
          let data = {
            campID: this.state.campID,
            startData: this.state.leadStartSelectedDate,
            endDate: this.state.leadEndSelectedDate,
          };
          // alert("data =>" + JSON.stringify(data))
          fetch("/dashboardCAT/downloadCATLeadFilter", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
          })
            .then((res) => res.json())
            .then((downloadFiles) => {
              // alert("downloadFiles =>" + JSON.stringify(downloadFiles))
              this.setState({ downloadFiles: downloadFiles });
              if (downloadFiles.success === true) {
                Swal.fire({
                  type: "error",
                  text: "No Data Exists!",
                  confirmButtonText: "Ok",
                  allowOutsideClick: false,
                });
                this.setState({ errors: errors });
              } else {
                var ws = xlsx.utils.json_to_sheet(downloadFiles);
                var wb = xlsx.utils.book_new();
                xlsx.utils.book_append_sheet(wb, ws, "Lead");
                var buf = xlsx.write(wb, {
                  bookType: "xlsx",
                  type: "buffer",
                }); // generate a nodejs buffer
                // var str = xlsx.write(wb, { bookType: 'xlsx', type: 'binary' });//kiran-4752-removing console warning-no used
                function s2ab(s) {
                  var buf = new ArrayBuffer(s.length);
                  var view = new Uint8Array(buf);
                  for (var i = 0; i !== s.length; ++i)
                    view[i] = s.charCodeAt(i) & 0xff;
                  return buf;
                }
                //var fileName = this.state.campID + "_QA_Leads" + ".xlsx";
                var fileName = "CAT_Review_" + campDetail[0].clientCampID + "_" + campID + ".xlsx";
                saveAs(
                  new Blob([s2ab(buf)], { type: "application/octet-stream" }),
                  fileName
                )
                Swal.fire({
                  text: "File Downloaded Successfully",
                  type: "success",
                  confirmButtonText: "Ok",
                  allowOutsideClick: false,
                });
              }
            });
        },
      });
    }
  } // End Of handleDownloadLeadDetails

  /**
  * @author Somnath Keswad
  * @param  Description handle the upload lead from submit button on portal
  * @return Description return All details of lead
  */
  // submitreviewlead(e) {
  //   e.preventDefault();

  //   var campID = this.state.campID;//sunita-task-3271-taken as per requirement.
  //   // const { user } = this.props.auth;
  //   // var advertiserID = user.id;//sunita-task-3271-taken as per requirement.
  //   // let errors = {};//kiran-4747-removing console warning-no used
  //   let data = {
  //     campID: campID,
  //     campaignLeadDetails: this.state.campaignLeadDetails,
  //     agencyID: this.state.reviewlead[0].agencyID
  //   }
  //   this.loadingRef.current.click();//Sandeep-task-3441-added code for loader
  //   fetch("/dashboardAdvertiser/uploadReviewLeadSubmit", {
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json' },
  //     body: JSON.stringify(data)
  //   }).then(res => res.json())
  //     .then(campaignLeadDetails => {

  //       let len = campaignLeadDetails.length;
  //       for (let i = 0; i < len; i++) {
  //         //kiran-4747-removing console warning-changed == to ===
  //         if (campaignLeadDetails[i].status === 'Advertiser Accepted') {
  //           campaignLeadDetails[i].status = "Accepted";
  //         }
  //         if (campaignLeadDetails[i].status === 'Advertiser Rejected') {
  //           campaignLeadDetails[i].status = "Rejected";
  //         }
  //       }
  //       this.setState({ campaignLeadDetails: campaignLeadDetails, reviewLeadFlag: true })
  //       if (campaignLeadDetails.length > 0) {
  //         // errors["leaderror"]="Lead reviewed successfully";

  //         this.closeLoadingRef.current.click();//Sandeep-task-3441-added code for loader
  //         Swal.fire({
  //           text: ("Lead reviewed successfully"),
  //           type: 'success',
  //           confirmButtonText: 'Ok',
  //           allowOutsideClick: false,
  //           preConfirm: () => {
  //             window.location.reload();
  //           }

  //         })

  //         //sunita-task-3271-added beow api for removing particular campaign id from left side after submiting the lead
  //         fetch("/dashboardAdvertiser/leadReviewCampID", {
  //           method: "POST",
  //           headers: { "Content-Type": "application/json" },
  //         })
  //           .then((res) => res.json())
  //           .then((listLeadCampID) => {
  //             this.closeLoadingRef.current.click();//Sandeep-task-3441-added code for loader
  //             this.setState(
  //               {
  //                 listLeadCampID: listLeadCampID,
  //               }
  //             );
  //           })
  //         //  this.setState({errors:errors,btnDisable:'disabled1'});

  //         this.setState({ btnDisable: 'disabled1' });
  //       } else {
  //         this.setState({ btnDisable: 'btn add-button' });
  //       }
  //     }).catch(function (err) { console.log(err) });
  // } // End of submitreviewlead

  backToDashboard(e) {
    e.preventDefault();//snehal-task-3724-vAPT URL changes
    const { user } = this.props.auth;
    this.props.history.push("/CATRole",
      // {advertiserID:user.id}
    )//snehal-task-3768-vAPT URL changes
  }

  /**
  * @author Priyanka Patil
  * @param  Description handle the refresh lead review page under task 4216
  * @return Campaign Details and Leads are displaying whose name in top in the left side list
  */

  fun_getCampDetailsFromTable(campID) {
    //const { user } = this.props.auth;
    // const { id: agencyID, role: userRole } = user;//kiran-4747-removing console warning-no used
    let data = { campID };
    fetch("/dashboardCAT/CATleadReviewCampID", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((listLeadCampID) => {
        //kiran-4747-added toString() and changed == to ===
        var campArray = listLeadCampID.filter((a) => {
          return a.campID.toString() === campID
        })
        if (campArray.length > 0) { }
        else {
          campID = listLeadCampID[0].campID;
        }
        this.setState(
          {
            campID, listLeadCampID, loading: false, loader2: ""
          }
        );
        this.getCampaignInfo(campID);
        this.fun_Get_Lead_TableData(campID);
      })
      .catch(function (err) { });
  }


  //Aman-4947-added startDatedateHandleChange to handle the lead startSelectedDate date
  startDatedateHandleChange(e) {
    e.preventDefault();
    var startSelectedDate = e.target.value;
    this.setState({ leadStartSelectedDate: startSelectedDate }, () => {
      this.filterleadByStartAndEndDate();
    });

    const reversedDate = this.reverseDateFormat(startSelectedDate); //Aman-4947 Output: "17-01-2024"
    this.setState({
      stectedStartDateforDisplay: reversedDate,
      selectedDateStart: startSelectedDate, //Aman-4947 Update state variable for input value
    });
  }
  //Aman-4947-added endDatedateHandleChange to handle the lead endSelectedDate date
  endDatedateHandleChange(e) {
    e.preventDefault();
    var endSelectedDate = e.target.value;
    this.setState({ leadEndSelectedDate: endSelectedDate }, () => {
      this.filterleadByStartAndEndDate();
    });

    const reversedDate = this.reverseDateFormat(endSelectedDate); ////Aman-4947- Output: "17-01-2024"
    this.setState({
      stectedEndDateforDisplay: reversedDate,
      selectedDateEnd: endSelectedDate, ////Aman-4947- Update state variable for input value
    });
  }

  //Aman-4947-added filterleadByStartAndEndDate to get filter lead from BE and return filter lead as per the date
  filterleadByStartAndEndDate(e) {
    if (
      this.state.leadStartSelectedDate !== "" &&
      this.state.leadEndSelectedDate !== ""
    ) {
      this.setState({ loading1: true, loader2: "loader_review" });
      let data = {
        campID: this.state.campID,
        startData: this.state.leadStartSelectedDate,
        endDate: this.state.leadEndSelectedDate,
      };
      //sunita-task-3271-display all diqa leads.
      fetch("/dashboardCAT/CATLeadDetailsFilter", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((leadDetails) => {
          let count = leadDetails.length;
          if (count < 0) {
            count = 0;
          }

          this.setState({
            filterleadDetails: leadDetails,
            filterleadDetailsCount: count,
            loading1: false,
            loader2: "",
            filterleadDetailsSatus: true,
            // leadStartSelectedDate: "",
            // leadEndSelectedDate: "",
          });
        })
        .catch(function (err) {
          console.log(err);
        });
    } else {
    }
  }

  //Aman-4947-added reverseDateFormat to format the selected date to display correct oder
  reverseDateFormat(originalDate) {
    //Aman-4947-added Split the original date string
    const dateParts = originalDate.split("-");

    //Aman-4947-added Rearrange the parts in the desired order
    const reversedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;

    return reversedDate;
  }
  render() {

    //  //sunita-task-3271- below all columns1,columns2 are used for antd table
    //  const columns1 = [
    //   {
    //     title: 'Lead ID',
    //     dataIndex: 'leadInfoID',
    //     key: 'leadInfoID',
    //     width: 90,
    //     align: 'left',//Sandeep-task-3441-algin table data to left   
    //     render: (text, record) =>
    //       <div >
    //         <span style={{ fontSize: '13px', color: '#4F4F4F' }}>
    //           {record.leadInfoID}
    //         </span>

    //       </div>
    //   },
    //   {
    //     title: 'Email',
    //     dataIndex: 'email',
    //     key: 'email',
    //     width: 105,
    //     align: 'left',//Sandeep-task-3441-algin table data to left   
    //     render: (text, record) =>
    //       <div >
    //         {/* <span style={{ fontSize: '11px',wordBreak: "break-all" }}> */}
    //         <span style={{ fontSize: '13px', color: '#4F4F4F', wordBreak: "break-all" }}>

    //           {record.email}
    //         </span>

    //       </div>
    //   },


    //   {
    //     title: 'Job Title',
    //     dataIndex: 'jobTitle',
    //     key: 'jobTitle',
    //     width: 90,
    //     align: 'left',//Sandeep-task-3441-algin table data to left   
    //     render: (text, record) =>
    //       <div >
    //         <span style={{ fontSize: '13px', color: '#4F4F4F' }}>
    //           {record.jobTitle}
    //         </span>

    //       </div>
    //   },
    //   {
    //     // title: 'Status',
    //     title:'Agency Status',
    //     dataIndex: 'agencyStatus',
    //     key: 'agencyStatus',
    //     width: 90,
    //     align: 'left',//Sandeep-task-3441-algin table data to left   
    //     render: (text, record, i) =>
    //       <div >
    //         <span style={{ fontSize: '14px', color: '#555555 ' }}>

    //             {record.agencyStatus}

    //         </span>

    //       </div>
    //   },


    //   {
    //     title: 'Advertiser Status',
    //     dataIndex: 'status',
    //     key: 'status',
    //     width: 90,
    //     align: 'left',//Sandeep-task-3441-algin table data to left   
    //     render: (text, record, i) => {
    //       const pageSize = this.state.pageSize; //Nilesh-5487- Number of rows per page
    //       const currentPage = this.state.tableState.current || 1; //Nilesh-5487- Current page
    //       const absoluteIndex = (currentPage - 1) * pageSize + i; //Nilesh-5487- Calculate absolute index
    //       return (
    //       <div>
    //         <span style={{ fontSize: '13px', color: '#4F4F4F' }}>

    //           {this.state.reviewLeadFlag === true ? (
    //             <label>{record.status}</label>
    //             ) : (
    //               <select
    //                 style={{ height: '60%' }}
    //                 id="status"
    //                 name="status"
    //                 value={record.status} //Nilesh-5487- Bind to the dataset value
    //                 onChange={(e) => this.handleChange(absoluteIndex, e)} //Nilesh-5487- Pass absolute index
    //                 className="form-control"
    //               >
    //                 <option value="Advertiser Accepted">Accepted</option>
    //                 <option value="Advertiser Rejected">Rejected</option>
    //               </select>
    //             )}
    //           </span>
    //         </div>
    //       )
    //     }
    //   },

    //   {
    //     title: 'Reason for Rejection',
    //     dataIndex: 'reason',
    //     key: 'reason',
    //     width: 90,
    //     align: 'left',//Sandeep-task-3441-algin table data to left   
    //     render: (text, record, i) => {
    //       const pageSize = this.state.pageSize;
    //       const currentPage = this.state.tableState?.current || 1;
    //       const absoluteIndex = (currentPage - 1) * pageSize + i; //Nilesh-5487- Calculate absolute index for proper binding
    //       return (
    //       <div >

    //         <span style={{ fontSize: '13px', color: '#4F4F4F' }}>

    //           {this.state.reviewLeadFlag ? (
    //               <input
    //                 type="textbox"
    //                 id={`reason-${absoluteIndex}`} //Nilesh-5487- Unique ID for input
    //                 name="reason"
    //                 value={record.reason || ""} //Nilesh-5487- Bind the input to the `reason` field
    //                 disabled={!(record.status === "Advertiser Rejected")} // Enable only for specific statuses
    //                 onChange={(e) => this.handleChange(absoluteIndex, e)} // Call handler on change
    //                 className="form-control"
    //               />
    //           ) : (
    //               <input
    //                 type="textbox"
    //                 id={`reason-${absoluteIndex}`} //Nilesh-5487-Unique ID for input
    //                 name="reason"
    //                 value={record.reason || ""} //Nilesh-5487-Bind the input to the `reason` field
    //                 disabled={!(record.status === "Advertiser Rejected")} // Enable only for specific statuses
    //                 onChange={(e) => this.handleChange(absoluteIndex, e)} // Call handler on change
    //                 className="form-control"
    //               />
    //           )}

    //         </span>

    //       </div>
    //       );
    //     }
    //   },
    // ]

    // //sunita-task-3271-added below all columns for antd table
    // const columns2 = [
    //   {
    //     title: 'Lead ID',
    //     dataIndex: 'leadInfoID',
    //     key: 'leadInfoID',
    //     width: 90,
    //     align: 'left',//Sandeep-task-3441-algin table data to left   
    //     render: (text, record) =>
    //       <div >
    //         <span style={{ fontSize: '13px', color: '#4F4F4F' }}>
    //           {record.leadInfoID}
    //         </span>

    //       </div>
    //   },
    //   {
    //     title: 'Email',
    //     dataIndex: 'email',
    //     key: 'email',
    //     width: 105,
    //     align: 'left',//Sandeep-task-3441-algin table data to left   
    //     render: (text, record) =>
    //       <div >
    //         {/* <span style={{ fontSize: '11px',wordBreak: "break-all" }}> */}
    //         <span style={{ fontSize: '13px', color: '#4F4F4F', wordBreak: "break-all" }}>

    //           {record.email}
    //         </span>

    //       </div>
    //   },


    //   {

    //     title: 'Voice Log Link',
    //     dataIndex: 'voiceLogLink',
    //     key: 'voiceLogLink',
    //     width: 90,
    //     align: 'left',//Sandeep-task-3441-algin table data to left   

    //     render: (text, record) =>
    //       <div >
    //         <span style={{ fontSize: '13px', color: '#1890FF' }}>
    //         {/* {record.callAudit}
    //           {record.channel} */}
    //           {this.state.marketingChannelFlag === true ?

    //           //sunita-task-3324-added condition as per channel for showing voicelog link column
    //           ((record.channel === "Telemarketing" ||record.Channel==="Telemarketing" )|| (((record.channel=== "Email/Telemarketing"||record.Channel==="Email/Telemarketing")||(record.channel==="Email"||record.Channel==="Email")) && record.callAudit==="Yes"))?
    //               //kiran-4747-removing console warning-added "#/"
    //               <a href='#/' onClick={this.openLinkInBrowser} id={record.leadInfoID}>Link</a>
    //               :
    //               <span style={{ fontSize: '13px', color: '#4F4F4F' }}>No Link Available</span>
    //             : ''}

    //         </span>

    //       </div>
    //   },


    //   {
    //     title: 'Job Title',
    //     dataIndex: 'jobTitle',
    //     key: 'jobTitle',
    //     width: 90,
    //     align: 'left',//Sandeep-task-3441-algin table data to left   
    //     render: (text, record) =>
    //       <div >
    //         <span style={{ fontSize: '13px', color: '#4F4F4F' }}>
    //           {record.jobTitle}
    //         </span>

    //       </div>
    //   },
    //   {
    //     // title: 'Status',
    //     title:'Agency Status',
    //     dataIndex: 'agencyStatus',
    //     key: 'agencyStatus',
    //     width: 90,
    //     align: 'left',//Sandeep-task-3441-algin table data to left   
    //     render: (text, record, i) =>
    //       <div >
    //         <span style={{ fontSize: '14px', color: '#555555 ' }}>

    //             {record.agencyStatus}

    //         </span>

    //       </div>
    //   },

    //   {
    //     title: 'Advertiser Status',
    //     dataIndex: 'status',
    //     key: 'status',
    //     width: 90,
    //     align: 'left',//Sandeep-task-3441-algin table data to left   
    //     render: (text, record, i) => {
    //       const pageSize = this.state.pageSize; //Nilesh-5487- Number of rows per page
    //       const currentPage = this.state.tableState.current || 1; //Nilesh-5487- Current page
    //       const absoluteIndex = (currentPage - 1) * pageSize + i; //Nilesh-5487- Calculate absolute index
    //       return (
    //         <div>
    //         <span style={{ fontSize: '13px', color: '#4F4F4F' }}>

    //             {this.state.reviewLeadFlag === true ? (
    //               <label>{record.status}</label>
    //             ) : (
    //               <select
    //                 style={{ height: '60%' }}
    //                 id="status"
    //                 name="status"
    //                 value={record.status} //Nilesh-5487- Bind to the dataset value
    //                 onChange={(e) => this.handleChange(absoluteIndex, e)} //Nilesh-5487- Pass absolute index
    //                 className="form-control"
    //               >
    //                 <option value="Advertiser Accepted">Accepted</option>
    //                 <option value="Advertiser Rejected">Rejected</option>
    //               </select>
    //             )}
    //           </span>
    //         </div>
    //       )
    //     }
    //   },

    //   {
    //     title: 'Reason for Rejection',
    //     dataIndex: 'reason',
    //     key: 'reason',
    //     width: 90,
    //     align: 'left',//Sandeep-task-3441-algin table data to left   
    //     render: (text, record, i) => {
    //       const pageSize = this.state.pageSize;
    //       const currentPage = this.state.tableState?.current || 1;
    //       const absoluteIndex = (currentPage - 1) * pageSize + i; // Calculate absolute index for proper binding
    //       return (
    //       <div >
    //         <span style={{ fontSize: '13px', color: '#4F4F4F' }}>

    //           {this.state.reviewLeadFlag ? (
    //               <input
    //                 type="textbox"
    //                 id={`reason-${absoluteIndex}`} //Nilesh-5487- Unique ID for input
    //                 name="reason"
    //                 value={record.reason || ""} //Nilesh-5487- Bind the input to the `reason` field
    //                 disabled={!(record.status === "Advertiser Rejected")} // Enable only for specific statuses
    //                 onChange={(e) => this.handleChange(absoluteIndex, e)} // Call handler on change
    //                 className="form-control"
    //               />
    //           ) : (
    //               <input
    //                 type="textbox"
    //                 id={`reason-${absoluteIndex}`} //Nilesh-5487-Unique ID for input
    //                 name="reason"
    //                 value={record.reason || ""} //Nilesh-5487-Bind the input to the `reason` field
    //                 disabled={!(record.status === "Advertiser Rejected")} // Enable only for specific statuses
    //                 onChange={(e) => this.handleChange(absoluteIndex, e)} // Call handler on change
    //                 className="form-control"
    //               />
    //           )}
    //         </span>
    //       </div>
    //       );
    //     }
    //   },

    // ]

    return (
      <div>
        <LeadReviewLoader
          loadingRef={this.loadingRef}
          closeLoadingRef={this.closeLoadingRef}
          message="Please wait. Saving the data...."
        />
        {/* Sandeep-task-3341-added code for loader */}
        <PublisherNavigation />
        <div class="container-fluid" style={{ paddingTop: '85px' }}>{/*sunita-task-3271-added code as per requirement */}

          {/* <div class="container-fluid" style={{ paddingTop: '85px' }}> */}
          {/*    
          <Tabs activeKey={this.state.key} onSelect={this.handleSelect}>  
          <Tab eventKey={1} title="Lead QA review by Agency"> */}

          {/* sunita-task-3271- added below code as per new screen requirement */}
          <div class="row" >
            <div class="container-fluid" style={{ marginTop: '10px' }}>
              <div class="row" style={{ paddingBottom: '6px' }}>
                <div class="col-md-2">
                  {/* kiran-4747-removing console warning-added "#/" */}
                  <a href="#/"> <FaArrowAltCircleLeft size={32} style={{ float: 'left', color: '#056eb8' }} title="Back to CAT Dashboard" onClick={this.backToDashboard.bind(this)} /></a>
                </div>

                {/* <div class="col-md-11"> */}
                <div class="col-md-8 reviewLead1"> {/*sunita-task-3727-added column as per requirement */}

                  <center ><label id="labeladvertiser" align="center" style={{ fontSize: "28px", fontFamily: 'roboto', fontWeight: "500", color: "#193D8F", textAlign: 'center' }}>Lead Assessment</label></center>

                </div>
              </div>
            </div>

          </div>
          <form name="reviewlead" encType="multipart/form-data" >

            <div class="card card-signin my-1" style={{ height: "45rem" }}>
              <div class="card-body" style={{ padding: '5px' }} >

                {/* sunita-task-3271- added below code as per new screen requirement */}
                <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 campaignslistsadv " style={{ background: '#FFFFFF', borderRight: '2px solid #eee', padding: '0px', height: '90px' }}>

                  <div>
                    {/* //sunita-task 3271- i have added black color for the label as per @Tanuja's suggetion (it was blue in screen)*/}
                    <label className="campLeadHeading" style={{ fontSize: '17px', color: '#14254A', marginTop: '10px', fontWeight: '500', fontFamily: 'roboto', marginLeft: '-63px' }}>Campaigns :</label>
                  </div>

                  {/* sunita-task-3271-added below code for as search */}
                  <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                      <span >
                        <input type="text" className="inputstyle4" name="search" placeholder="Search Campaign"
                          style={{
                            backgroundImage: 'url(searchIcon.png)',
                            backgroundPosition: '15px 6px',
                            backgroundSize: '15px 15px',
                            backgroundRepeat: "no-repeat",
                            width: '280px',
                            height: '28px',
                            fontSize: '12px',
                            // float: 'left',
                            // marginLeft: '17px',
                            border: '1px solid #CCCCCC',
                            padding: '12px 20px 15px 36px',
                            backgroundColor: "#FFFFFF",
                            // marginBottom: '5px',
                            // borderBottom: '1px solid #eee',
                            fontFamily: 'sans-serif',
                            borderRadius: '2px',
                          }}
                          onChange={this.handleChangeSearch} onPressEnter={this.handleChangeSearch}
                        >
                        </input>
                      </span>
                    </div>
                  </div>

                  <br />
                  <hr />


                  {/* sunita-task-3271-added below condition as search table data */}
                  <div style={{ overflowY: 'scroll', height: '35rem', background: '#FFFFFF', padding: '0px', borderRight: '2px solid #eee', marginTop: '-9px' }}> {/*sunita-task-3271-added col and it's data as per requirement */}


                    {this.state.tableSearchText === "" ?

                      <div  >
                        {this.state.listLeadCampID.map(listLeadCampID => (
                          <div style={{ borderBottom: '1px solid #eee', padding: '5px 15px' }} className="campNames">
                            {/* kiran-4747-removing console warning-added "#/" */}
                            <a href="#/" className="reviewcampdata" id={listLeadCampID.campID} onClick={this.advLeadreviewDetails}>{listLeadCampID.campID} - {listLeadCampID.clientCampID} - {listLeadCampID.campaignName} </a>{/* Saurabh – Task- 3747 – Adding Agency campaign ID i.e clientCampID */}
                          </div>
                        ))}

                      </div>

                      :

                      this.state.listLeadCampIDSearch.length > 0 ?
                        <div >

                          {this.state.listLeadCampIDSearch.map(listLeadCampIDSearch => (
                            <div style={{ borderBottom: '1px solid #eee', padding: '5px 15px' }} className="campNames">
                              <a href="#/" className="reviewcampdata" id={listLeadCampIDSearch.campID} onClick={this.advLeadreviewDetails}>{listLeadCampIDSearch.campID} - {listLeadCampIDSearch.clientCampID} - {listLeadCampIDSearch.campaignName} </a>{/* Saurabh – Task- 3747 – Adding Agency campaign ID i.e clientCampID */}
                            </div>
                          ))}

                        </div>

                        : <center><label style={{ color: 'red', fontSize: 'medium', marginTop: '34px' }}>No Data Exist</label></center>
                    }

                  </div>

                </div>

                <div className="col-xs-12 col-sm-9 col-md-9 col-lg-9 col-xl-9" style={{ background: '#FFFFFF', paddingTop: '20px' }}>{/*sunita-task-3271-added before whole data in this column as per requirement */}
                  <div >
                    {/* {alert("this.state.campaignLeadDetails" + JSON.stringify(this.state.campaignLeadDetails))}
                   {alert("this.state.listLeadCampID" + JSON.stringify(this.state.listLeadCampID))}
                   {alert("  this.state.reviewlead" + JSON.stringify(this.state.reviewlead))} */}
                    {((this.state.campaignLeadDetails.length > 0) && (this.state.listLeadCampID.length > 0)) && (  //Rutuja task 5634 disabled camp info  when there is no data
                      this.state.reviewlead.map(
                        reviewlead => (
                          <div class="row" style={{ marginTop: '-9px' }}>

                            {/* <div class="col-sm-2"> */}
                            {/*sunita-task-3271-added below label css changes for campID,campname,start date,end date and status as per new requirement for alignment*/}
                            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-4">
                              <label style={{ fontSize: '14px', color: 'black', fontWeight: '600' }}>
                                Campaign ID :
                              </label>
                              &nbsp;<span>{reviewlead.parentCampID}</span>
                            </div>

                            {/* <div class="col-sm-3" > */}
                            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-4">
                              <label style={{ fontSize: '14px', color: 'black', fontWeight: '600' }} >
                                Campaign Name :
                              </label>
                              &nbsp;<span className="reviewcampdata1">{reviewlead.campaignName}</span>
                            </div>

                            {/* <div class="col-sm-3"> */}
                            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-4">
                              <label style={{ fontSize: '14px', color: 'black', fontWeight: '600' }} >Campaign Type : </label>
                              &nbsp;<span>{reviewlead.ABM}</span>
                            </div>


                            {/* <div class="col-sm-2"> */}
                            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-4">
                              <label style={{ fontSize: '14px', color: 'black', fontWeight: '600' }} >Start Date : </label>
                              &nbsp;<span>{reviewlead.startDate}</span>
                            </div>


                            {/* <div class="col-sm-2"> */}
                            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-4">
                              <label style={{ fontSize: '14px', color: 'black', fontWeight: '600' }} >End Date : </label>
                              &nbsp;<span>{reviewlead.endDate}</span>
                            </div>

                            {/* <div class="col-sm-2"> */}
                            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-4">
                              <label style={{ fontSize: '14px', color: 'black', fontWeight: '600' }} >Total Leads : </label>
                              &nbsp;<span>{this.state.campaignLeadDetails.length}</span>
                            </div>
                          </div>
                        ))
                    )}
                  </div>
                  <br />
                  <hr />

                  {/* Aman-4947-added below all row inside code to display inpute filed to filter lead as per the dates */}
                  <div className="row">
                    <div
                      className="col-xs-5 col-sm-5 col-md-7 col-lg-7 col-xl-5"
                      id="dateForm"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        gap: "3",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          flexWrap: "wrap",
                        }}
                      >
                        <label
                          style={{
                            fontSize: "14px",
                            color: "#14254A",
                            fontFamily: "sans-serif",
                            marginRight: "10px",
                          }}
                        >
                          Lead Start Date&nbsp;&nbsp;
                          <HtmlTooltip
                            placement="right"
                            title={
                              <React.Fragment>
                                <ol>
                                  <li>
                                    {/* 4433-validation changes */}
                                    {
                                      'Selected date range will list the lead data on  "Leads Created Date" only.'
                                    }
                                  </li>
                                  <li>
                                    {
                                      "Start Date and End Date both need to select to filter the lead data."
                                    }
                                  </li>
                                </ol>
                              </React.Fragment>
                            }
                          >
                            <Icon type="question-circle" />
                          </HtmlTooltip>
                        </label>

                        <input
                          type="date"
                          id="startDate"
                          name="startDate"
                          min=""
                          pattern="[0-9]{2}-[0-9]{2}-[0-9]{4}"
                          value={this.state.selectedDateStart}
                          onChange={this.startDatedateHandleChange}
                          className="form-control"
                          required
                        />
                      </div>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          flexWrap: "wrap",
                        }}
                      >
                        <label
                          style={{
                            fontSize: "14px",
                            color: "#14254A",
                            fontFamily: "sans-serif",
                            marginRight: "10px",
                          }}
                        >
                          Lead End Date&nbsp;&nbsp;
                          <HtmlTooltip
                            placement="right"
                            title={
                              <React.Fragment>
                                <ol>
                                  <li>
                                    {/* 4433-validation changes */}
                                    {
                                      'Selected date range will list the lead data on  "Leads Created Date" only.'
                                    }
                                  </li>
                                  <li>
                                    {
                                      "Start Date and End Date both need to select to filter the lead data."
                                    }
                                  </li>
                                </ol>
                              </React.Fragment>
                            }
                          >
                            <Icon type="question-circle" />
                          </HtmlTooltip>
                        </label>

                        <input
                          type="date"
                          id="endDate"
                          name="endDate"
                          min=""
                          pattern="[0-9]{2}-[0-9]{2}-[0-9]{4}"
                          value={this.state.selectedDateEnd}
                          onChange={this.endDatedateHandleChange}
                          className="form-control"
                          required
                        />
                      </div>

                      {/* {this.state.selectedDateStart === "" ? ("") : (<p style={{color: "red"}}>please select End Date to also to get lead count as per the Date</p>)} */}
                    </div>
                  </div>
                  <br />

                  {/* </div>
                <br /> */}

                  <div class="row" style={{ marginTop: '10px', marginBottom: '10px' }}>{/*sunita-task-3160-added row and column as per requirement */}
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-3">
                      <button title="Leads reviewed by the QA team will be displayed" class="btn add-button" type="button" onClick={this.handleDownloadLeadDetails} style={{ backgroundColor: "#056eb8", color: "white", height: '32px', fontSize: '14px', fontFamily: 'sans-serif', fontWeight: '400', borderRadius: '4px' }}
                        disabled={((this.state.campaignLeadDetails.length === 0) && (this.state.listLeadCampID.length === 0))}  //Rutuja task 5634 disabled download leads button when there is no data
                      > {/*sunita-task-3271-added as per requirement */}
                        Download Leads
                      </button>
                    </div>
                  </div>
                  <span style={{ display: "flex" }}>
                    <b title="This lead count is based on the selected date range filter.">Total Leads :</b>{" "}
                    {this.state.filterleadDetailsSatus === true ? (
                      <div >
                        &nbsp;
                        <b>
                          {this.state.filterleadDetailsCount}
                        </b> from{" "}
                        <b>{this.state.stectedStartDateforDisplay}</b>{" "}
                        to <b>{this.state.stectedEndDateforDisplay}</b>
                      </div>
                    ) : (
                      <b>&nbsp;{this.state.leadDetails.length}</b>
                    )}
                  </span>
                  <div id={this.state.loader2}></div>
                  {/* //Sandeep-task-3341 */}
                  {/* <Table {...this.state.tableState}
                        id="myTable"
                        bordered
                        dataSource={this.state.campaignLeadDetails}
                        onChange={this.onTableChange} //Nilesh-5487- call onTableChange function

                         columns={this.state.marketingChannelFlag === true ? columns2 : columns1}
                        // columns={columns1}
                        //loading={this.state.loading}
                        // className="ant-table-thead"
                        // className={tableCSS}
                        className={`${tableCSS} "ant-table-thead"`} //kiran-4747-removing console warning-changed classname
                        // scroll={{ x: 1375, y: 4000 }}
                        scroll={{ x: 1375, y: 1333 }}
                        pagination={{
                          pageSize: this.state.pageSize,
                          position: "bottom",

                        }}>

                      </Table> */}
                  {/* sunita-task-3271-added below code for paginaion */}
                  {/* <div class="row">
                        <div
                          class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"
                          style={{ marginTop: "-52px", marginLeft: "5px", fontSize: '13px', color: '#4F4F4F', fontFamily: 'sans-serif' }}>
                          &nbsp;Records per page:&nbsp;
                                <select
                            defaultValue={this.state.pageSize}
                            onChange={this.handleChangePageSize}
                            id="pacing1"
                            class="input-small"
                            className="form-control"
                            name="pacing"
                            style={{ width: "71px", height: "30px", display: "initial", fontSize: '13px', fontFamily: 'sans-serif', color: '#4F4F4F' }}>
                            <option value="100" selected>
                              100
                                  </option>
                            <option value="200">200</option>
                            <option value="300">300</option>
                          </select>
                        </div>
                      </div> */}

                  <br />
                </div>
              </div>
            </div>


          </form>
        </div>




        <Footer />
      </div>
    )
  }

}

CATReviewLead.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
  auth: state.auth
})

export default connect(mapStateToProps, { logoutUser })(withRouter(CATReviewLead));
